import { c as _c } from "react/compiler-runtime";
import { SEOMetadata, SEOMetadataProps } from '@src/components/sco/utilities/SEOMetadata';
export const LandingPageSEO = props => {
  const $ = _c(3);
  let t0;
  if ($[0] !== props.landingPage.description || $[1] !== props.landingPage.title) {
    const seoProps = {};
    seoProps.title = props.landingPage.title;
    seoProps.description = props.landingPage.description;
    t0 = <><SEOMetadata {...seoProps} /></>;
    $[0] = props.landingPage.description;
    $[1] = props.landingPage.title;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  return t0;
};